<template>
  <span class="bg-red color-white addItem">
    <!-- uuid: {{ uuid }} -->
    <center class="color-black">DATA</center>
    <!-- {{ items }} -->
  </span>
</template>

<script>

export default {
  props: ['items'],
  created() {
    
    
  }
};
</script>